import { Component, Input } from '@angular/core';
import { Question } from '../question';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent {
	@Input() question: Question;
  @Input() final: boolean;

  constructor() { }
}
